import { Route, Routes } from "react-router-dom";
import { PlatformPoliciesEntryPage } from "~/entry-pages/platform/policies/PlatformPoliciesEntryPage";
import { PlatformPoliciesAddEntryPage } from "~/entry-pages/platform/policies/PlatformPoliciesAddEntryPage";
import { PlatformPolicyDetailEntryPage } from "~/entry-pages/platform/policies/PlatformPolicyDetailEntryPage";
import { PlatformPolicyOverviewTab } from "~/pages/platform/policy/tabs/PlatformPolicyOverviewTab";
import { PlatformPolicyChecksTab } from "~/pages/platform/policy/tabs/PlatformPolicyChecksTab";
import { PlatformPolicyExceptionsTab } from "~/pages/platform/policy/tabs/PlatformPolicyExceptionsTab";
import { PlatformPolicyPropertiesTab } from "~/pages/platform/policy/tabs/PlatformPolicyPropertiesTab";
import { useFeatureFlags } from "~/providers/FeatureFlagsProvider";
import { PlatformCheckDetailPage } from "~/pages/platform/check";
import {
  PlatformCheckResultsTab,
  PlatformCheckRemediationTab,
  PlatformCheckDetailsTab,
} from "~/pages/platform/check/tabs";
import { PlatformPoliciesAddDetailEntryPage } from "~/entry-pages/platform/policies/PlatformPoliciesAddDetailEntryPage";
import { PlatformPoliciesAddDetailChecksPage } from "~/pages/platform/policies-add/PlatformPoliciesAddDetailChecksPage";
import { PlatformPoliciesAddQueryDetailEntryPage } from "~/entry-pages/platform/policies/PlatformPoliciesAddQueryDetailEntryPage";

export function PlatformPoliciesRoutes() {
  const { isFeatureEnabled } = useFeatureFlags();
  return (
    <Routes>
      <Route index element={<PlatformPoliciesEntryPage />} />
      {isFeatureEnabled("Platform Policy Add") && (
        <Route path="/add">
          <Route index element={<PlatformPoliciesAddEntryPage />} />
          <Route
            path=":policyId"
            element={<PlatformPoliciesAddDetailEntryPage />}
          >
            <Route index element={<PlatformPoliciesAddDetailChecksPage />} />
            <Route
              path={"checks"}
              element={<PlatformPoliciesAddDetailChecksPage />}
            />
          </Route>
          <Route
            path=":policyId/queries/:queryId"
            element={<PlatformPoliciesAddQueryDetailEntryPage />}
          />
        </Route>
      )}
      <Route path="/:policyId" element={<PlatformPolicyDetailEntryPage />}>
        <Route index element={<PlatformPolicyOverviewTab />} />
        <Route path="overview" element={<PlatformPolicyOverviewTab />} />
        <Route path="checks" element={<PlatformPolicyChecksTab />} />
        <Route path="exceptions" element={<PlatformPolicyExceptionsTab />} />
        <Route path="properties" element={<PlatformPolicyPropertiesTab />} />
      </Route>
      <Route path="/:policyId/check" element={<PlatformCheckDetailPage />}>
        <Route index element={<PlatformCheckResultsTab />} />
        <Route path="results" element={<PlatformCheckResultsTab />} />
        <Route path="remediation" element={<PlatformCheckRemediationTab />} />
        <Route path="details" element={<PlatformCheckDetailsTab />} />
      </Route>
    </Routes>
  );
}
